var _style, _g, _g2, _path, _path2, _g3, _path3, _g4, _g5, _g6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTm(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#496E2D;}\n\t.st1{fill:#F0F0F0;}\n\t.st2{fill:#D80027;}\n\t.st3{fill:#FF9811;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M256,0c-19.1,0-37.7,2.1-55.7,6.1L189.2,256l11.1,249.9c17.9,4,36.5,6.1,55.7,6.1c141.4,0,256-114.6,256-256 C512,114.6,397.4,0,256,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M66.8,83.6C25.3,129.1,0,189.6,0,256s25.3,126.9,66.8,172.4L77.9,256L66.8,83.6z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M374.4,193.1c12.6-35.1-1.6-73.3-31.9-92.3c5.5,0.7,10.9,2,16.3,3.9c40.5,14.5,61.6,59.1,47,99.6 c-14.5,40.5-59.1,61.6-99.6,47c-5.4-1.9-10.4-4.4-15.1-7.3C326.6,248.7,361.8,228.2,374.4,193.1L374.4,193.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M304.6,91.2l-10.9,14.1l-16.8-6l10.1,14.8l-10.9,14.1l17.2-5l10.1,14.8l0.5-17.9l17.2-5l-16.8-6L304.6,91.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M334.1,137.3l-10.9,14.1l-16.8-6l10.1,14.8l-10.9,14.1l17.2-5l10.1,14.8l0.5-17.9l17.2-5l-16.8-6L334.1,137.3z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M252.5,108l-10.9,14.1l-16.8-6l10.1,14.8L223.8,145l17.2-5l10.1,14.8l0.5-17.9l17.2-5l-16.8-6L252.5,108z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M251.3,160.7l-10.9,14.1l-16.8-6l10.1,14.8l-10.9,14.1l17.2-5l10.1,14.8l0.5-17.9l17.2-5l-16.8-6L251.3,160.7z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M301.5,178.8l-10.9,14.1l-16.8-6l10.1,14.8l-10.9,14.1l17.2-5l10.1,14.8l0.5-17.9l17.2-5l-16.8-6L301.5,178.8z "
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M66.8,83.6v344.9c34.9,38.3,81.2,65.9,133.6,77.5V6.1C148,17.7,101.7,45.3,66.8,83.6L66.8,83.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M117.8,134.8l-22.4-16.7V94.6l22.4-16.7h31.6l22.4,16.7v23.6l-22.4,16.7H117.8z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M133.6,77.9h-15.8L95.4,94.6v11.5h38.2V77.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M133.6,134.8h15.8l22.4-16.7v-12h-38.2L133.6,134.8z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M117.8,434.1l-22.4-16.7v-23.6l22.4-16.7h31.6l22.4,16.7v23.6l-22.4,16.7H117.8z"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M133.6,377.2h-15.8l-22.4,16.7v11.5h38.2V377.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M133.6,434.1h15.8l22.4-16.7v-12h-38.2L133.6,434.1z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M117.8,284.4l-22.4-16.7v-23.6l22.4-16.7h31.6l22.4,16.7v23.6l-22.4,16.7H117.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M172.5,321.1h-9.7v-9.7h-17.1l-12.1-12.1l-12.1,12.1h-17.1v9.7h-9.7v19.5h9.7v9.7h17.1l12.1,12.1l12.1-12.1 h17.1v-9.7h9.7V321.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M172.5,171.4h-9.7v-9.7h-17.1l-12.1-12.1l-12.1,12.1h-17.1v9.7h-9.7v19.5h9.7v9.7h17.1l12.1,12.1l12.1-12.1 h17.1v-9.7h9.7V171.4z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M122.4,244.9h22.3v22.3h-22.3L122.4,244.9z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 133.6,
    cy: 181.2,
    r: 11.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 133.6,
    cy: 330.8,
    r: 11.1
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTm);
export default __webpack_public_path__ + "static/media/tm.954a8f3f87ab95bb1fa034e9db5295f2.svg";
export { ForwardRef as ReactComponent };